module.exports = require("core-js/modules/es.string.replace.js");